export const GO_TO_CART_CTA = "Go to Cart";
export const ADD_DETAILS_CTA = "Add details";
export const PAY_CTA = "Pay";
export const VIEW_ACTIONS_CTA = "View actions";

export type FilingActionCtaLabel =
  | typeof GO_TO_CART_CTA
  | typeof ADD_DETAILS_CTA
  | typeof PAY_CTA
  | typeof VIEW_ACTIONS_CTA;
